export default "__VITE_ASSET__0BQkOYWb__"